/***************************************************************************/
"use client";
/***************************************************************************/

import { useQuery } from "@/client/api/use-query";
import PageLoading from "@/client/components/page-loading";
import React, { useEffect, useRef, useState } from "react";
import { mutate } from "swr";

const ServerConnectionGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { loading, status } = useQuery("/heart-beat", {
    refreshInterval: 1000 * 60,
    refreshWhenHidden: false,
    revalidateOnFocus: true,
    revalidateOnMount: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
  });
  const [polling, setPolling] = useState(false);
  const refTimer = useRef<NodeJS.Timeout | undefined>(undefined);

  const startPolling = () => {
    clearTimeout(refTimer.current);

    setPolling(true);

    refTimer.current = setTimeout(() => {
      mutate("/heart-beat");
    }, 1000);
  };

  const stopPolling = () => {
    setPolling(false);
    clearTimeout(refTimer.current);
  };

  useEffect(() => {
    if (status === "success") {
      stopPolling();
    } else if (status === "error") {
      mutate(() => true, undefined, {
        revalidate: false,
      }).then(() => {
        startPolling();
      });
    }
  }, [status]);

  useEffect(() => {
    return () => {
      stopPolling();
    };
  }, []);

  if (loading || polling || status === "error") {
    return <PageLoading />;
  }

  return children;
};

export { ServerConnectionGuard };
